export default __webpack_public_path__ + "static/media/series.b8702172.png";